import { savedSearchActionTypes as actionType } from 'src/constants/actionTypes';

const initialState = {
  list: [],
  success: '',
  error: '',
};

const savedSearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionType.SAVE_SUCCESS: {
      const { savedSearch, successMsg } = action.payload;
      return {
        ...state,
        list: [...state.list, savedSearch],
        success: successMsg,
      };
    }

    case actionType.GET_ALL_SUCCESS: {
      const { savedSearchList } = action.payload;
      return {
        ...state,
        list: savedSearchList,
      };
    }

    case actionType.DELETE_SUCCESS: {
      const { id } = action.payload;
      return {
        ...state,
        list: state.list.filter((search) => search.id !== id)
      };
    }

    case actionType.FAILURE: {
      const { error } = action.payload;
      return {
        ...state,
        success: '',
        error
      };
    }

    case actionType.CLEAR_MESSAGES: {
      return {
        ...state,
        success: '',
        error: ''
      };
    }

    default: {
      return state;
    }
  }
};

export default savedSearchReducer;
